import type { SVGProps } from "react";
import React from "react";

export const PinterestColor: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="14" cy="14" r="14" fill="white" />
    <path
      d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 19.6801 3.38269 24.5702 8.24348 26.7655C8.25001 26.6141 8.25734 26.4752 8.26364 26.3561C8.27221 26.1938 8.27885 26.0682 8.27885 25.9976C8.27885 25.5769 8.56491 23.4904 8.56491 23.4904L10.3149 16.3053C10.0457 15.8678 9.84375 14.9423 9.84375 14.2356C9.84375 10.9711 11.6611 10.2644 12.7716 10.2644C14.1851 10.2644 14.5048 11.7957 14.5048 12.9231C14.5048 13.5194 14.1955 14.4528 13.8772 15.4134C13.5398 16.4314 13.1923 17.4799 13.1923 18.1899C13.1923 19.5697 14.5553 20.2596 15.4976 20.2596C17.988 20.2596 20.2764 17.1298 20.2764 14C20.2764 10.8702 18.8125 7.08412 14.0168 7.08412C9.22116 7.08412 7.06731 10.7356 7.06731 13.5288C7.06731 15.4134 7.77404 16.7933 8.12741 17.0288C8.22837 17.1186 8.4 17.3957 8.27885 17.786C8.15769 18.1764 7.9367 19.0481 7.84135 19.4351C7.83013 19.5248 7.72356 19.6774 7.38702 19.5697C6.96635 19.4351 4.29087 17.7524 4.29087 13.5288C4.29087 9.30528 7.60577 4.39182 14.0168 4.39182C20.4279 4.39182 23.7091 8.69951 23.7091 14C23.7091 19.3005 19.4183 22.6827 16.1538 22.6827C13.5423 22.6827 12.5192 21.516 12.3341 20.9327L11.3413 24.7187C11.1069 25.3468 10.6696 26.4757 10.1304 27.4583C11.3594 27.8111 12.6576 28 14 28Z"
      fill="#BB0F23"
    />
  </svg>
);
